import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { Check } from 'lucide-react';
const tags = ['Tareas', 'Crisis', 'Concentración', 'Lectura', 'Colegio', 'Obra Social', 'Pre-adolescencia', 'Autocuidado', 'Rutinas visuales', 'Derechos legales', 'Comunicación', 'Planificación'];
const skills = ['Manejar crisis sin perder la calma', 'Acompañar las tareas sin conflicto', 'Sostener la concentración de tu hijo', 'Hablar con el colegio y que te escuchen', 'Reclamar cobertura a la obra social', 'Construir rutinas que se sostienen solas', 'Acompañar la pre-adolescencia con TDAH', 'Cuidarte para poder seguir cuidándolo'];
export function SystemOverview() {
  return <section className="py-12 md:py-20 bg-[#1E2A4A] text-white" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <div className="text-center mb-8 md:mb-12" data-id="element-239">
          <span className="inline-block text-[#E76F51] font-bold tracking-wider uppercase text-xs md:text-sm mb-3 md:mb-4" data-id="element-240">
            EL SISTEMA MÁS COMPLETO DE ARGENTINA PARA FAMILIAS CON TDAH
          </span>
          <p className="text-lg md:text-2xl font-medium text-white/90 mb-6 md:mb-8" data-id="element-241">
            Hacelo Hoy · 8 Tomos + 6 Bonos · Familias con niños de 5 a 13 años ·
            Todo resuelto.
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-8 md:mb-10" data-id="element-242">
            <div className="bg-white/10 px-4 py-2 md:px-6 md:py-3 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-243">
              <span className="block text-2xl md:text-3xl font-bold text-white" data-id="element-244">
                +380 pág.
              </span>
            </div>
            <div className="bg-white/10 px-4 py-2 md:px-6 md:py-3 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-245">
              <span className="block text-2xl md:text-3xl font-bold text-white" data-id="element-246">
                50+ herramientas
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 max-w-4xl mx-auto mb-8 md:mb-12" data-id="element-247">
            {tags.map((tag, i) => <span key={i} className="bg-white/5 text-white/80 px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-xs md:text-sm border border-white/10" data-id="element-248">
                {tag}
              </span>)}
          </div>

          <p className="text-xl md:text-2xl font-bold text-[#E76F51] mb-8 md:mb-16 px-4" data-id="element-249">
            Funciona desde hoy en tu casa, con los recursos que ya tenés.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white/5 rounded-2xl md:rounded-3xl p-6 md:p-12 border border-white/10" data-id="element-250">
          <h3 className="text-xl md:text-2xl font-bold mb-6 md:mb-8 text-center" data-id="element-251">
            Habilidades que vas a desarrollar:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-4" data-id="element-252">
            {skills.map((skill, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-2.5 md:gap-3" data-id="element-253">
                <div className="bg-[#8A9A86] rounded-full p-1 mt-0.5 shrink-0" data-id="element-254">
                  <Check className="text-white w-3 h-3 md:w-4 md:h-4" data-id="element-255" />
                </div>
                <span className="text-sm md:text-lg text-white/90" data-id="element-256">
                  {skill}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}